var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Drawer', {
    attrs: {
      "width": "400",
      "title": `${_vm.openedSales ? '编辑' : '新增'}销售记录`
    },
    model: {
      value: _vm.drawerOpened,
      callback: function ($$v) {
        _vm.drawerOpened = $$v;
      },
      expression: "drawerOpened"
    }
  }, [_c('div', {
    staticClass: "drawer-content"
  }, [_c('Form', {
    ref: "formItem",
    attrs: {
      "model": _vm.formItem,
      "rules": _vm.ruleValidate,
      "label-position": "top"
    },
    nativeOn: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "内容",
      "prop": "content"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "show-word-limit": "",
      "rows": 6,
      "maxlength": "200",
      "placeholder": "在此填写销售记录..."
    },
    model: {
      value: _vm.formItem.content,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "content", $$v);
      },
      expression: "formItem.content"
    }
  })], 1), _c('FormItem', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.handleSubmit('formItem');
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }